export default __webpack_public_path__ + "/images/birth-of-the-universe.jpg";